module.exports = __webpack_public_path__ + "img/Spinner-1s-50px.66a7b01d.svg";